<template>
  <certificate-content />
</template>
<script>
import CertificateContent from "./CertificateContent.vue";

export default {
  components: {
    CertificateContent
  }
};
</script>

<style lang="scss"></style>
